export const COVERAGE_TYPE = {
  ANYONE_MARKET: 'anyone_market',
  FREE_TEXT: 'free_text',
  PREFERRED_PROVIDER: 'preferred_provider',
} as const;

export const COVERAGE_LABELS: Record<string, string> = Object.assign(
  Object.create(null) as Record<string, string>,
  {
    [COVERAGE_TYPE.ANYONE_MARKET]: 'Anyone in Market',
    [COVERAGE_TYPE.PREFERRED_PROVIDER]: 'Preferred Provider',
    [COVERAGE_TYPE.FREE_TEXT]: 'Free Text',
  },
);
